import { makeStyles } from '@material-ui/core';
import axios from 'api/axios';
import { useSearchParams } from 'hooks/useSearchParams';
import { localText } from 'langs/fa/data-grid';
import React, { useReducer, useState } from 'react';
import { useQuery } from 'react-query';
import { useMainStore } from 'useStores/useMainStore';
import DataGrid from 'components/DataGrid/DataGrid';
import { useHistory } from 'react-router-dom';
import useTitle from 'hooks/useTitle';
import { initialState, reducer } from './reducer';
import { useLocation } from 'react-router-dom';
import { useFreight } from 'useStores/useFreight';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    width: '100%',
    height: 480,
    '& .pending': {
      background: '#ffecb3',
    },
    '& .tendering': {
      background: '#e6ee9c',
    },
    '& .getWaybill': {
      background: '#bbdefb',
    },
    '& .rejected': {
      background: '#e0e0e0',
    },
    '& .loadTime': {
      fontSize: 12,
    },
    '& .colHeader': {
      background: '#607d8b',
      color: '#fff',
    },
  },
  fleetCount: {
    '& > span.red': {
      background: '#dd2c00',
      color: '#fff',
      padding: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    '& > span.green': {
      background: '#76ff03',
      padding: theme.spacing(1),
    },
  },
  allOrders: {
    position: 'absolute',
    bottom: 15,
    left: 150,
  },
}));

const FreightsList = () => {
  const classes = useStyles();
  useTitle('سفارشات باربری');
  const [addTitle] = useTitle('سفارشات باربری');
  const [state, dispatch] = useReducer(reducer, initialState);
  const limit = useMainStore((state) => state.limit);
  const [params, setParams] = useSearchParams();
  const [totalPages, setTotalPages] = useState(null);
  const history = useHistory();
  const location = useLocation();
  const parentUrl = `/protected/admin/freights/freightsList`;
  const setTitle = useFreight((state) => state.setTitle);
  const setCategory = useFreight((state) => state.setCategory);
  const setFreightsList = useFreight((state) => state.setFreights);

  const columns = [
    {
      field: 'customer',
      headerName: 'صاحب بار',
      renderCell: ({ value }) => <>{value}</>,
      flex: 1,
      // cellClassName: ({ value: { status } }) => status,
      // headerClassName: 'colHeader',
    },
    {
      field: 'pendingOrders',
      headerName: 'سفارشات در حال بررسی',
      width: 230,
      renderCell: ({ value }) => <>{value}</>,
      // cellClassName: ({ value: { status } }) => status,
      // headerClassName: 'colHeader',
    },
    {
      field: 'activeOrders',
      headerName: 'سفارشات جاری',
      width: 200,
      renderCell: ({ value }) => <>{value}</>,
      // cellClassName: ({ value: { status } }) => status,
      // headerClassName: 'colHeader',
    },
    {
      field: 'successOrders',
      headerName: 'سفارشات موفق',
      width: 200,
      renderCell: ({ value }) => <>{value}</>,
      // cellClassName: ({ value: { status } }) => status,
      // headerClassName: 'colHeader',
    },
    {
      field: 'canceledOrders',
      headerName: 'سفارشات کنسلی',
      width: 200,
      renderCell: ({ value }) => <>{value}</>,
      // cellClassName: ({ value: { status } }) => status,
      // headerClassName: 'colHeader',
    },
  ];

  function handlePageChange(page) {
    setParams([{ name: 'page', value: page }]);
  }

  function handleOrders(status, array) {
    const item = array?.find((item) => item.status === status);
    return item;
  }

  function handleSelectFreight(data) {
    history.push(`/protected/admin/freights/freightOrders/${data.row.id}`);
  }

  const fetchFreights = async () => {
    const { data } = await axios.get(
      `/api/v1/admin/freight/list?page=${
        params.get('page') || 1
      }&limit=${limit}`
    );
    setFreightsList(data);
    data.totalPages && setTotalPages(data.totalPages);
    return data;
  };

  const { data, isLoading } = useQuery(
    ['freights', params.get('page'), limit],
    () => fetchFreights(),
    { refetchOnWindowFocus: false }
  );

  React.useEffect(() => {
    setTitle('لیست سفارشات باربری‌ها');
    setCategory('نمایش سفارشات باربری‌ها به ترتیب سفارشات جاری');
  }, [location.pathname]);

  return (
    <div className={classes.root}>
      <DataGrid
        rows={
          (data?.docs.length > 0 &&
            data?.docs?.map((freight) => ({
              id: freight._id?._id,
              customer: freight._id?.company
                ? freight._id?.company
                : `${freight?._id?.firstName} ${freight?._id?.lastName}`,
              pendingOrders:
                handleOrders('pending', freight?.counts)?.pendingCount || '-',
              activeOrders:
                handleOrders('inProgress', freight?.counts)?.inProgress || '-',
              successOrders:
                handleOrders('delivered', freight?.counts)?.deliveredCount ||
                '-',
              canceledOrders:
                handleOrders('canceled', freight?.counts)?.cancelledCount ||
                '-',
            }))) ||
          []
        }
        columns={columns}
        localeText={localText}
        pageSize={Number(limit)}
        rowCount={data?.totalDocs || 0}
        paginationMode="server"
        onPageChange={handlePageChange}
        loading={isLoading}
        disableMultipleSelection
        // onCellClick={handleSelectOrder}
        density="compact"
        // onSelectionChange={handleSelectOrder}
        disableSelectionOnClick
        // components={{
        //   NoRowsOverlay: NoDrivers,
        // }}
        pageNumber={params.get('page') ? Number(params.get('page')) : 1}
        // checkboxSelection={true}
        // hasSelectAll
        footerPagination={true}
        totalPages={totalPages}
        defaultPage={params.get('page') * 1 || 1}
        onCellClick={handleSelectFreight}
      />
    </div>
  );
};

export default FreightsList;
